var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserDataProvider',{scopedSlots:_vm._u([{key:"default",fn:function({loaded}){return [(loaded)?_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('v-icon',[_vm._v(_vm._s(_vm.icon))])]})],2):_vm._e()]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }